<template>
  <f7-panel
    left
    resizable
    :backdrop="false"
    class="sendMessageLeftPanel"
    :style="{
      width: f7.width >= 768 ? '418px' : '100%',
      'min-width': f7.width >= 768 ? '418px' : '100%',
      'border-right':
        'var(--f7-page-master-border-width) solid var(--f7-page-master-border-color)',
    }"
  >
    <f7-view>
      <f7-page>
        <f7-navbar no-shadow>
          <f7-nav-left>
            <f7-link
              panel-close="left"
              icon-only
              icon-ios="f7:multiply"
              icon-md="material:close"
            ></f7-link>
          </f7-nav-left>
          <f7-nav-title :title="$t('tamtam.newChat')"></f7-nav-title>
        </f7-navbar>
        <userslist> </userslist>
        <f7-list
          dividers-ios
          strong-ios
          media-list
          v-if="searchedUser !== ''"
          class="search-list searchbar-found"
        >
          <f7-list-item v-if="searchedUser!==null"
            :title="searchedUser.name"
            @click="createGroup(searchedUser)"
            :subtitle="searchedUser.phoneNumber"
            :footer="searchedUser.tag"
            link="#"
            panel-close
            :reload-detail="false"
          >
            <template #media>
              <img
                v-if="searchedUser.logo !== null"
                :src="`${searchedUser.logo}`"
                style="height: 48px; width: 48px; border-radius: 25px"
              />
              <f7-badge
                color="auto"
                v-if="searchedUser.logo === null && searchedUser.name !== null"
                style="
                  height: 48px;
                  width: 48px;
                  font-size: 16px;
                  border-radius: 25px;
                "
                >{{
                  $filtersGetInitial.getInitial(searchedUser.name)
                }}</f7-badge
              >
            </template>
            <template #after>
              <f7-link
                color="red"
                icon-ios="f7:multiply"
                @click="clearSearchedUser()"
                icon-md="material:close"
              >
              </f7-link>
            </template>
          </f7-list-item>
        </f7-list>
        <span
          id="userRecipientlist"
          class="margin-top"
          v-if="searchedUser === ''"
        >
          <f7-block-title medium class="margin-left margin-top">{{
            $t("tamtam.recentlyUsed")
          }}</f7-block-title>
          <f7-list
            dividers-ios
            strong-ios
            media-list
            v-if="groupList && groupList.length > 0"
          >
            <template v-for="chatGrp in groupList.slice(0, 10)" :key="chatGrp.id">
              <f7-list-item
                v-if="chatGrp && chatGrp.groupType === 'GROUP'"
                :link="'/message/' + chatGrp.id + '/' + chatGrp.groupType"
              panel-close
              :reload-detail="false"
              :title="chatGrp.name"
              :text="chatGrp.description"
            >
              <template #media>
                <img
                  v-if="chatGrp.avatar !== null"
                  :src="`${chatGrp.avatar}`"
                  width="40"
                  style="height: 48px; width: 48px; border-radius: 25px"
                />
                <f7-badge
                  v-else
                  color="auto"
                  style="
                    height: 48px;
                    width: 48px;
                    font-size: 16px;
                    border-radius: 25px;
                  "
                  >{{ $filtersGetInitial.getInitial(chatGrp.name) }}</f7-badge
                >
              </template>
              <f7-list
                media-list
                v-if="
                  chatGrp.subGroupList && chatGrp.subGroupList.length > 0
                "
              >
                <f7-list-item
                  v-if="
                    chatGrp.groupType === 'PERSONAL' &&
                    chatGrp.groupParticipantList.find(
                      (x) => x.userId !== profile.sub,
                    ) !== null
                  "
                  :link="'/message/' + chatGrp.id + '/' + chatGrp.groupType"
                  panel-close
                  :reload-detail="false"
                >
                  <template
                    #media
                    v-if="
                      chatGrp.groupParticipantList &&
                      chatGrp.groupParticipantList.length > 0
                    "
                    :title="
                      chatGrp.groupParticipantList.find(
                        (x) => x.userId !== profile.sub,
                      ).username
                    "
                  >
                    <img
                      v-if="
                        chatGrp.groupParticipantList.find(
                          (x) => x.userId !== profile.sub,
                        ) !== null &&
                        chatGrp.groupParticipantList.find(
                          (x) => x.userId !== profile.sub,
                        ).avatar !== null
                      "
                      :src="`${
                        chatGrp.groupParticipantList.find(
                          (x) => x.userId !== profile.sub,
                        ).avatar
                      }`"
                      width="40"
                      style="height: 48px; width: 48px; border-radius: 25px"
                    />
                    <f7-badge
                      v-if="
                        chatGrp.groupParticipantList.find(
                          (x) => x.userId !== profile.sub,
                        ).avatar === null &&
                        chatGrp.groupParticipantList.find(
                          (x) => x.userId !== profile.sub,
                        ).name !== null
                      "
                      color="auto"
                      style="
                        height: 48px;
                        width: 48px;
                        font-size: 16px;
                        border-radius: 25px;
                      "
                      >{{
                        $filtersGetInitial.getInitial(
                          chatGrp.groupParticipantList.find(
                            (x) => x.userId !== profile.sub,
                          ).name,
                        )
                      }}</f7-badge
                    >
                  </template>
                </f7-list-item>
                <f7-list-item
                  v-for="chatSbGroup in chatGrp.subGroupList"
                  :key="chatSbGroup.id"
                  :link="
                    '/message/' + chatSbGroup.id + '/' + chatSbGroup.groupType
                  "
                  panel-close
                  :reload-detail="false"
                  :text="chatSbGroup.description"
                  :title="chatSbGroup.name"
                >
                  <template #media>
                    <img
                      v-if="chatSbGroup.avatar !== null"
                      :src="`${chatSbGroup.avatar}`"
                      style="height: 36px; width: 36px; border-radius: 25px"
                    />
                    <f7-badge
                      v-else
                      color="auto"
                      style="
                        height: 36px;
                        width: 36px;
                        font-size: 12px;
                        border-radius: 25px;
                      "
                      >{{
                        $filtersGetInitial.getInitial(chatSbGroup.name)
                      }}</f7-badge
                    >
                  </template>
                </f7-list-item>
              </f7-list>
            </f7-list-item>
            </template>
          </f7-list>
          <f7-list
            media-list
            v-if="counterPartUserList && counterPartUserList.length > 0"
          >
            <template v-for="user in counterPartUserList" :key="user.id">
            <f7-list-item
              v-if="!!user"
              :link="'/message/' + user.userId + '/' + 'PERSONAL'"
              :title="user.name"
              :after="'+' + user.phoneNumber"
              :footer="user.tag"
              ><template #media>
                <img
                  v-if="user.avatar !== null"
                  :src="`${user.avatar}`"
                  width="40"
                  style="height: 48px; width: 48px; border-radius: 25px"
                />
                <f7-badge
                  color="auto"
                  v-if="user.avatar === null && user.name !== null"
                  style="
                    height: 48px;
                    width: 48px;
                    font-size: 16px;
                    border-radius: 25px;
                  "
                  >{{ $filtersGetInitial.getInitial(user.name) }}</f7-badge
                >
              </template></f7-list-item
            >
            </template>
          </f7-list>
        </span>
        <f7-link
          class="searchbar-hide-on-search margin-left"
          :text="$t('tamtam.newGroup')"
          @click="openCreateGroupLeftPanel()"
          icon-ios="f7:person_3"
          icon-md="material:groups"
          style="border-radius: 25px"
        >
        </f7-link>
      </f7-page>
    </f7-view>
  </f7-panel>
</template>
<style scoped></style>
<script setup>
import { computed } from "vue";
import { f7, f7ready, theme } from "framework7-vue";
import { useMessageStore } from "../../js/pinia-stores/message.js";
import { useAccountStore } from "../../js/pinia-stores/account.js";
import { useAuthStore } from "../../js/pinia-stores/auth.js";
import { useMessageGroup } from "../../js/composables/useMessage.js";
import { useGroupCreation } from "../../js/composables/useGroupCreation.js";
import userslist from "../users.vue";

defineProps({
  f7route: Object,
  f7router: Object,
});

const messageStore = useMessageStore();
const accountStore = useAccountStore();
const authStore = useAuthStore();
const profile = computed(() => authStore.profile);
const searchedUser = computed(() => accountStore.searchedUser);
const groupList = computed(() => messageStore.groupList);
const counterPartUserList = computed(() => messageStore.counterPartUserList);

// Opens a one to one chat with the picked contact. Group and sub-group
// creation is owned by the shared creation panel.
const { createGroup } = useMessageGroup({});
const { openGroupCreation } = useGroupCreation();

function openCreateGroupLeftPanel() {
  openGroupCreation();
}

function clearSearchedUser() {
  accountStore.setUser("");
}
</script>
